var map = {
	"./IR showcase.svg": "fb3f",
	"./IR showroom.svg": "58ae",
	"./IR story.svg": "bf26",
	"./IR.svg": "74ed",
	"./In-page.svg": "a77d",
	"./MIB動畫.svg": "63e7",
	"./MIR SKIRT+.svg": "9e61",
	"./MIR Story.svg": "d358",
	"./MIRI.svg": "673b",
	"./MIRS.svg": "8cea",
	"./MIRT.svg": "748f",
	"./MIRV.svg": "2a4c",
	"./MIT.svg": "6569",
	"./幀互動.svg": "3205",
	"./橫互動.svg": "f872"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5acc";